import "react-app-polyfill/ie11";
import ReactDOM from "react-dom";
import { HashRouter } from "react-router-dom";
import App from "./App.tsx";
import "./index.css";

import { SCSContexto } from "./components/scs/SCSContexto";
import { ToastProvider } from "./contexts/ToastContext";
import { OverlayProvider } from "./contexts/OverlayContext";
import { ErrorBoundary } from "./components/ErrorBoundary";

import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";

const renderApp = (scs, erroSCS) =>
  ReactDOM.render(
    <SCSContexto.Provider value={scs}>
      <HashRouter>
        <ErrorBoundary>
          <OverlayProvider>
            <ToastProvider>
              <App erroSCS={erroSCS}></App>
            </ToastProvider>
          </OverlayProvider>
        </ErrorBoundary>
      </HashRouter>
    </SCSContexto.Provider>,
    document.getElementById("root")
  );

// UserService.initKeycloak(initSCS(renderApp));

process.env.NODE_TLS_REJECT_UNAUTHORIZED = "0";
renderApp();
